<template>
  <div class="details-view tab-approval-matters" style="height: 600px !important;">
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      style="min-height:90%"
    >
      <template slot="left">
        <cargo-ag-grid
          :grid-options="leftGridOptions"
          :row-data="leftRowData"
          :show-side-bar="false"
          min-height="100%"
          class="section"
          grid-style="min-width: 240px;width:100%;height:100%;"
          @gridReady="p=>{gridApi=p.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations">
            <div style="margin: 6px">
              <el-button no="refresh" type="primary" @click="fetchData(true)">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
              <el-button no="moreFilter" type="primary" @click="moreFilter">{{ $t('CargoMsg.Cargo_MoreFilters') }}</el-button>
              <el-button v-show="showDealBtn" no="handled" type="success" @click="batchApprove($t('CargoMsg.Cargo_Agree'), 7001)">{{ $t('CargoMsg.Cargo_Agree') }}</el-button>
              <el-button v-show="showDealBtn" no="ignoreMessage" type="danger" @click="batchApprove($t('CargoMsg.Cargo_Refuse'), 7002)">{{ $t('CargoMsg.Cargo_Refuse') }}</el-button>
            </div>
          </div>
          <approval-list-grid
            ref="approvalListGrid"
            :key="gridKey"
            config-module="23030702"
            :type="type"
            :document-config-id-prop="documentConfigId"
            :per-config-name="perConfigName"
            :grid-refresh-id="gridRefreshId"
            :total="filter.total"
            :status="status"
            :row-data="rowData"
            :dynamics="true"
            @toQuery="toQuery"
            @changeSelected="changeSelected"
          />
        </div>
      </template>
    </cargo-left-right-resize>
    <more-approval-filter-dialog
      :visible.sync="filterDialog.visible"
      :filter="filter"
      :type="type"
      :document-config-id="documentConfigId"
      :per-config-name-prop.sync="perConfigName"
      :grid-refresh-id-prop.sync="gridRefreshId"
      @toQuery="toQuery"
      @close="filterDialog.visible=false"
    />
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
    />
  </div>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import MoreFilterDialog from '@/views/dashboard/admin/components/PreWarning/components/moreFilterDialog'
import ApprovalListGrid from '@/views/cargo/v0/ApprovalMatters/ApprovalChecklist/components/approvalListGrid'
import { manageIndexCount, workflowActionBatch, workflowPendingList, workflowSelfList } from '@/api/workflow'
import { getLoading } from '@/utils/utilBaseElement'
import ApprovalSearch from '@/components/Cargo/Common/Wrokflow/approvalSearch'
import MoreApprovalFilterDialog
  from '@/views/dashboard/admin/components/PreWarning/components/moreApprovalFilterDialog'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import {
  BILL_PAYMENT,
  CHARGE_CHANGE,
  COLLECT_INVOICE,
  CONTRACT_APPLICATION_FORM,
  Job_CHARGE,
  MAKE_INVOICE,
  PARTNER_APPLICATION_FORM,
  TEMP_CREDIT,
  VIEW_SOURCE_HANDLE_TODO,
  VIEW_SOURCE_INITIATE_PROCESSING
} from '@/class/cargo/model/parameters/WorkflowConstants'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'

export default {
  name: 'TabApprovalMatters',
  components: { MoreApprovalFilterDialog, ApprovalSearch, ApprovalListGrid, MoreFilterDialog, CargoAdvanceSelect, CargoLeftRightResize, batchSubmitOrApproveDialog },
  props: {
    approvalMatter: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      type: 'look',
      status: 0,
      showDealBtn: false,
      rowData: [],
      filter: {
        total: 0,
        // pageNum: 0,
        // pageSize: 10,
        startDate: '',
        officeIdList: [],
        workflowName: '',
        approvalDate: '',
        approveIdList: [],
        state: 0,
        approvalTemplate: '',
        documentConfigIdList: [],
        documentProcessNo: '',
        applicationDimensions: [],
        requireCargoColumndefs: false
      },
      filterDialog: {
        visible: false
      },
      selectedRows: [],
      leftRowData: [],
      gridApi: null,
      leftGridOptions: {
        treeData: true,
        rowSelection: 'single',
        groupDefaultExpanded: 0,
        defaultColDef: {
          lockPosition: false // 禁止拖动列的位置
        },
        // columnDefs: [
        //   {
        //   headerName: this.$t('CargoMsg.Cargo_MyApprovals'),
        //   colId: '',
        //   field: '',
        //   width: 200,
        //   cellRenderer: (params) => {
        //     if (params.data.count === 0) {
        //       return `<i class="el-icon-warning"></i><span>${params.data.name}</span>`
        //     }
        //     const colorClass = params.data.count > 0 ? 'radio-number has-data' : 'radio-number no-data'
        //     return `<i class="el-icon-warning"></i><span>${params.data.name}</span><span class="${colorClass}"><span class="number"> ${params.data.count}</span></span>`
        //   }
        // }
        // ],
        // columnDefs: [
        //   {
        //     headerName: 'Path',
        //     field: 'path',
        //     width: 80,
        //     hide: true
        //   }
        // ],
        suppressContextMenu: false,
        context: {
          componentParent: this
        },
        onCellClicked: (event) => {
          sessionStorage.setItem('lastClickedRowIndex', event.rowIndex)
          this.leftGridOnCellClicked(event)
        },
        onCellDoubleClicked: event => {},
        getDataPath: (data) => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_MyApprovals'),
          width: 280,
          tooltipValueGetter: (params) => {
            return ''
          },
          cellRendererParams: {
            suppressCount: true,
            innerRenderer: (params) => {
              if (params.data.count === 0) {
                return `<i class="el-icon-warning"></i><span>${params.data.name}</span>`
              }
              const colorClass = params.data.count > 0 ? 'radio-number has-data' : 'radio-number no-data'
              return `<i class="el-icon-warning"></i><span>${params.data.name}</span><span class="${colorClass}"><span class="number"> ${params.data.count}</span></span>`
            }
          }
        }
      },
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      documentConfigId: 0,
      gridKey: 0,
      perConfigName: '',
      gridRefreshId: 0
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    officeId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchData()
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.fetchData()
    })
  },
  methods: {
    async fetchData(isRefresh = false) {
      const topRowData = [
        // code对应documentConfigId，0表示没有
        { type: 'look', name: this.$t('CargoMsg.Cargo_ApprovalsThatIInitiated'), count: 0, path: '1', code: 0 },
        { type: 'look', name: this.$t('CargoMsg.Cargo_BillPayment'), count: 0, path: '1,1', code: BILL_PAYMENT.code },
        { type: 'look', name: this.$t('CargoMsg.Cargo_MakeInvoice'), count: 0, path: '1,2', code: MAKE_INVOICE.code },
        { type: 'look', name: this.$t('CargoMsg.Cargo_JobCharge'), count: 0, path: '1,3', code: Job_CHARGE.code },
        { type: 'look', name: this.$t('CargoMsg.Cargo_TempCreditApply'), count: 0, path: '1,4', code: TEMP_CREDIT.code },
        { type: 'look', name: this.$t('CargoMsg.Cargo_ChargeChangeApply'), count: 0, path: '1,5', code: CHARGE_CHANGE.code },
        { type: 'look', name: this.$t('CargoMsg.Cargo_CollectInvoiceApply'), count: 0, path: '1,6', code: COLLECT_INVOICE.code },
        { type: 'look', name: this.$t('CargoMsg.Cargo_PartnerApplicationForm'), count: 0, path: '1,8', code: PARTNER_APPLICATION_FORM.code },
        { type: 'look', name: this.$t('CargoMsg.Cargo_ContractApplicationForm'), count: 0, path: '1,9', code: CONTRACT_APPLICATION_FORM.code }
      ]
      const bottomRowData = [
        // code对应documentConfigId，0表示没有
        { type: 'approve', name: this.$t('CargoMsg.Cargo_ApprovalsThatIHandle'), count: 0, path: '2', code: 0 },
        { type: 'approve', name: this.$t('CargoMsg.Cargo_BillPayment'), count: 0, path: '2,1', code: BILL_PAYMENT.code },
        { type: 'approve', name: this.$t('CargoMsg.Cargo_MakeInvoice'), count: 0, path: '2,2', code: MAKE_INVOICE.code },
        { type: 'approve', name: this.$t('CargoMsg.Cargo_JobCharge'), count: 0, path: '2,3', code: Job_CHARGE.code },
        { type: 'approve', name: this.$t('CargoMsg.Cargo_TempCreditApply'), count: 0, path: '2,4', code: TEMP_CREDIT.code },
        { type: 'approve', name: this.$t('CargoMsg.Cargo_ChargeChangeApply'), count: 0, path: '2,5', code: CHARGE_CHANGE.code },
        { type: 'approve', name: this.$t('CargoMsg.Cargo_CollectInvoiceApply'), count: 0, path: '2,6', code: COLLECT_INVOICE.code },
        { type: 'approve', name: this.$t('CargoMsg.Cargo_PartnerApplicationForm'), count: 0, path: '2,8', code: PARTNER_APPLICATION_FORM.code },
        { type: 'approve', name: this.$t('CargoMsg.Cargo_ContractApplicationForm'), count: 0, path: '2,9', code: CONTRACT_APPLICATION_FORM.code }
      ]
      await manageIndexCount().then(res => {
        topRowData[0].count = res.data.selfProcessingCount
        bottomRowData[0].count = res.data.pendingProcessingCount
        this.approvalMatter.count = res.data.pendingProcessingCount + res.data.selfProcessingCount
        this.leftRowData = [...topRowData, ...bottomRowData]
        this.$nextTick(() => {
          if (!isRefresh) {
            const lastClickedRowIndex = sessionStorage.getItem('lastClickedRowIndex')
            const index = lastClickedRowIndex ? Number(lastClickedRowIndex) : 0
            this.leftGridOptions.api.setFocusedCell(index, this.leftGridOptions.api.columnController.getAllDisplayedColumns()[0])
          }
          const cell = this.leftGridOptions.api.getFocusedCell()
          const nodes = this.leftGridOptions.api.rowModel.rowsToDisplay
          const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
          this.leftGridOnCellClicked(node)
        })
        const approvalMattersRoutes = this.$store.state.permission.routes.filter(route => route.path === '/ApprovalMatters')
        if (approvalMattersRoutes && approvalMattersRoutes.length > 0) {
          approvalMattersRoutes[0].badgeCount = res.data.pendingProcessingCount
        }
      })
    },
    applyCloseAndRefresh() {
      // this.workFlowApplyDialog.visible = false
      this.fetchData(true)
      this.$emit('reloadCount')
    },
    clearGrid() {
      this.filter = {
        total: 0,
        // pageNum: 1,
        // pageSize: 50,
        startDate: '',
        officeIdList: [],
        workflowName: '',
        approvalDate: '',
        approveIdList: [],
        state: 0,
        approvalTemplate: '',
        documentConfigIdList: [],
        documentProcessNo: '',
        requireCargoColumndefs: false
      }
      this.leftGridOptions.api.refreshCells({ force: true })
      this.leftGridOptions.api.clearFocusedCell()
    },
    toQuery() {
      this.filter.pageNum = this.$refs.approvalListGrid.filter.pageNum
      this.filter.pageSize = this.$refs.approvalListGrid.filter.pageSize
      // 左边菜单是否选中【表单类型】
      if (this.documentConfigId) {
        this.filter.documentConfigIdList = [this.documentConfigId]
        this.filter.requireCargoColumndefs = true
      }
      const params = this.filter
      WorkflowUtil.changeFilter(params)
      if (this.type === 'look') {
        this.filter.viewSource = VIEW_SOURCE_INITIATE_PROCESSING.code
        this.loading = getLoading('tab-approval-matters')
        workflowSelfList(this.filter).then(res => {
          params.total = res.data.total
          this.rowData = res.data.list
        }).finally(() => {
          this.loading.close()
        })
      }
      if (this.type === 'approve') {
        this.filter.viewSource = VIEW_SOURCE_HANDLE_TODO.code
        this.loading = getLoading('tab-approval-matters')
        workflowPendingList(this.filter).then(res => {
          params.total = res.data.total
          this.rowData = res.data.list
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    moreFilter() {
      this.filterDialog.visible = true
    },
    leftGridOnCellClicked(event) {
      this.filter = {
        total: 0,
        // pageNum: 1,
        // pageSize: 50,
        startDate: '',
        officeIdList: [],
        workflowName: '',
        approvalDate: '',
        approveIdList: [],
        state: 0,
        approvalTemplate: '',
        documentConfigIdList: [],
        documentProcessNo: '',
        requireCargoColumndefs: false
      }
      const data = event.data
      this.showDealBtn = data.type === 'approve'
      // 刷新显示列
      if (this.type !== data.type || this.documentConfigId !== data.code) {
        this.gridKey += 1
      }
      this.filter.total = 0
      // this.filter.pageNum = 1
      // this.filter.pageSize = 50
      this.type = data.type
      this.documentConfigId = data.code
      this.$nextTick(async() => {
        this.toQuery()
      })
    },
    // 批量操作
    batchApprove(actionName, actionType) {
      const selectRows = this.getSelectedRows()
      if (selectRows === null) {
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureToDo', [actionName]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const params = []
        for (const row of selectRows) {
          const param = {
            documentConfigId: row.documentConfigId,
            docId: row.docId,
            docNo: row.billPaymentNo,
            actionType: actionType,
            documentProcessId: row.documentProcessId,
            documentProcessNo: row.documentProcessNo,
            applicationDimension: row.applicationDimension
          }
          params.push(param)
        }
        this.loading = getLoading('tab-approval-matters')
        workflowActionBatch(params).then(res => {
          if (!res.data || res.data.length === 0) {
            this.$message.success(actionName + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
          } else {
            this.batchSubmitOrApproveDialog.visible = true
            this.batchSubmitOrApproveDialog.rowData = res.data
          }
          this.fetchData(true)
        }).finally(() => {
          this.selectedRows = []
          this.loading.close()
        })
      }).catch(() => { })
    },
    changeSelected(list) {
      this.selectedRows = list
    },
    // 获取待审核的勾选数据
    getSelectedRows() {
      const selectedRows = this.selectedRows
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return null
      }
      return selectedRows
    }
  }
}
</script>

<style lang="scss">
  @import "~@/styles/element-variables.scss";
  .tab-approval-matters{
    .el-icon-warning{
      font-size: 14px;
      margin-right: 5px;
    }
    .radio-number{
      border-radius: 24%;
      height: 18px;
      width: 30px;
      display: inline-block;
      float: right;
      margin: 4px;
      .number{
        display: block;
        color: #FFFFFF;
        height: 18px;
        line-height: 18px;
        text-align: center
      }
    }
    .has-data{
      background: #f56c6c;
    }
    .no-data{
      background: #42B983;
    }
    .el-icon-remove{
      font-size: 16px;
      color: $--color-primary;
    }
  }
</style>
